module.exports = __webpack_public_path__ + "img/consultoria_9-16_810.4f562de2.webp";